import React from 'react';
import { Users } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const PassengersSection = ({ passengers }) => {
  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <Users className="h-5 w-5 text-blue-500" />
        <h5 className="font-semibold">Passengers</h5>
        <Badge variant="info" className="text-xs">{passengers.length}</Badge>
      </div>

      {passengers.length === 0 ? (
        <p className="text-slate-500 text-sm text-center py-4">No passengers yet</p>
      ) : (
        <div className="space-y-4">
          {passengers.map((passenger, index) => (
            <div
              key={passenger.id || index}
              className="pl-3 border-l-2 border-blue-200"
            >
              <p className="text-sm text-slate-500">{passenger.first_name}</p>
              <p className="font-semibold text-slate-900">{passenger.last_name}</p>
              {passenger.birthdate && (
                <p className="text-xs text-slate-400 mt-1">Born: {passenger.birthdate}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PassengersSection;
